import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { TfiControlShuffle } from 'react-icons/tfi';

function PFReport({branchID ,companyID}) {


    const [noteType, setNoteType] = useState(null);
    const [fetchData, setfetchData] = useState([]);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [branchDetail, setBranchDetail] = useState([])
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };

    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState('');
      const [company, setCompany] = useState([]);

    const reportOptions = [
        { value: 'pf_left_emp', label: 'PF Left Emp (Form 10 )' },
        { value: 'pf_annual', label: 'PF Annual/Monthly/Quaterly (Form 6A)' },
        { value: 'pf_contribution_card', label: 'PF Contribution Card (Form 3A)' },
        // { value: 'pf_return_form', label: 'PF Monthly Return Form ' },
        { value: 'pf_new_emp', label: 'PF New Employee (Form 5)' },
        // { value: 'pf_monthly', label: 'PF Monthly ' },
        // { value: 'pf_quaterly', label: 'PF Quaterly ' },
        { value: 'pf_challan', label: 'PF Challan ' },
    ]


       const fetchCompany = async () => {
          
            try {
              const res = await axios.get(`https://api.skyguard.group/api/fetch-company-localData/${companyID}`);
              setCompany(res.data);
            } catch (error) {
              console.log(error)
            } 
          };

              const fetchBranchDetail = async () => {
          
                  try {
                      const resInventory = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
                      setBranchDetail(resInventory.data)
          
          
                  } catch (error) {
                      console.log(error)
                  } 
              };


                useEffect(() => {
                  fetchBranchDetail();
              
                  fetchCompany();
                }, []);


    const isAnnual =
  noteType?.value === 'pf_annual' ||
  noteType?.value === 'pf_contribution_card' ||
  noteType?.value === 'pf_challan';

const handleSearch = async (e) => {
  e.preventDefault();

  if (!noteType?.value ) {
    setToast('Please select a report type', 'warning');
    return;
  }

    if (!fromDate || !toDate) {
    setToast('Please select From Date and To Date', 'warning');
    return;
  }

  try {
    const params = {
      noteType: noteType.value,
       from_date: fromDate,  
      to_date: toDate
    };

    console.log({ fromDate,toDate });

    const result = await axios.get(
      'https://api.skyguard.group/api/get-pf-report',
      { params }
    );

  const resultData = result?.data || [];
   
    setfetchData(resultData);
      console.log(resultData);

  } catch (error) {
    console.error('❌ Error fetching report:', error);
    setToast('Error fetching report. Please try again.', 'danger');
  }
};

function calculatePF(monthlyBasic) {
  const employeePF = monthlyBasic * 0.12;
  const employerEPF = monthlyBasic * 0.0367;
  const employerEPS = monthlyBasic * 0.0833;

  return {
    employeePF,
    employerEPF,
    employerEPS,
    totalPF: employeePF + employerEPF + employerEPS
  };
}

const financialMonths = [
  "Apr", "May", "Jun", "Jul", "Aug", "Sep",
  "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"
];

const normalizeData = (data) => {
  return financialMonths.map((month) => {
    const found = data.find(d => d.month === month);
    return found || {
      month,
      basic_salary: 0,
      emp_id: data[0]?.emp_id,
      emp_name: data[0]?.emp_name
    };
  });
};

const formattedData = Array.isArray(fetchData)
  ? normalizeData(fetchData)
  : [];



const grouped = fetchData.reduce((acc, item) => {
  if (!acc[item.emp_id]) {
    acc[item.emp_id] = {
      emp_id: item.emp_id,
      emp_name: item.emp_name,
      months: []
    };
  }

  acc[item.emp_id].months.push(item);

  return acc;
}, {});


function getEarnedBasic(item) {
  const totalDays = (item.paid_days + item.absent_days) || 30;
  return (Number(item.basic_salary) / totalDays) * (item.paid_days || 0);
}

function calculatePF(earnedBasic) {
  return {
    employeePF: earnedBasic * 0.12,
    employerEPF: earnedBasic * 0.0367,
    employerEPS: earnedBasic * 0.0833,
  };
}

    const handlePrint = () => {
        const content = document.getElementById("exportTable");

        if (!content) return;

        const printWindow = window.open("", "", "width=900,height=700");

        printWindow.document.write(`
  <html>
    <head>
      <title>AMC Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 10px;
          margin: 0;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
          word-wrap: break-word;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          font-size: 12px;
        }

        /* Prevent overflow */
        div {
          overflow: visible !important;
        }

        /* Fit content inside page */
        @page {
          size: A4 landscape;
          margin: 10mm;
        }
      </style>
    </head>
    <body>
      ${content.outerHTML}
    </body>
  </html>
`);
        printWindow.document.close();
        printWindow.focus();


        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    return (
        <div className='main-section'>

            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'> Report</h3>



                <div className="row g-3 align-items-end">
                    <div className="col-md-4">
                        <label className='fw-bold'>Select Report</label>
                        <Select
                            options={reportOptions}
                            placeholder="Choose Type ..."
                            id="source"
                            value={noteType}

                            onChange={(selected) => {
                                setNoteType(selected);
                                setfetchData([]);
                            }}
                        />
                    </div>

                                  {!isAnnual ? (
  <>
    <div className="col-md-4">
      <label className='fw-bold'>From Date</label>
      <input
        type="date"
        className="form-control"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
    </div>

    <div className="col-md-4">
      <label className='fw-bold'>To Date</label>
      <input
        type="date"
        className="form-control"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
      />
    </div>
  </>
) : (
  <>
    <div className="col-md-4">
      <label className='fw-bold'>From Month</label>
      <input
        type="month"
        className="form-control"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
    </div>

    <div className="col-md-4">
      <label className='fw-bold'>To Month</label>
      <input
        type="month"
        className="form-control"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
      />
    </div>
  </>
)}


                    <div className="col-md-12 d-flex justify-content-end align-items-end">
                       
                        <FaSearch size={26} className="ms-1 text-primary"
                            style={{ cursor: "pointer" }}
                            title="Search"
                            onClick={handleSearch}
                        />

                        <MdLocalPrintshop
                            size={26}
                            className="ms-1 text-success"
                            onClick={handlePrint}
                            style={{ cursor: "pointer" }}
                            title="Print "
                        />
                    </div>


                </div>



                 <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                 {noteType?.value === 'pf_left_emp' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Emp ID</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>DOJ</th>
                  
                   <th>Sepearation Date</th>
                    
                  </tr>
                </thead>
               <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
   

      return (
        <tr key={idx}>
          <td>{item.emp_id}</td>
          <td>{item.first || ""} {item.middle || ""}  {item.last || ""}   </td>
          <td>{item.phone} </td>
          <td>{item.doj} </td>
       

         <td>{item.seperation_date} </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td >No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}


                {noteType?.value === 'pf_annual' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
               <tr>
  <th>Emp ID</th>
  <th>Name</th>

<th>Month</th>
<th>Year</th>
  <th>Basic</th>
  <th>Employee PF (12%)</th>
  <th>Employer EPF (3.67%)</th>
  <th>Employer EPS (8.33%)</th>
  <th>Total PF</th>
</tr>
                </thead>
      
<tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {

      const totalDays = (item.paid_days || 0) + (item.absent_days || 0) || 30;
const perDayBasic = Number(item.basic_salary || 0) / totalDays;

const earnedBasic = perDayBasic * (item.paid_days || 0);

const pf = calculatePF(earnedBasic);
      // const pf = calculatePF(basic);

  
      const [year, monthNum] = (item.month || "").split("-");

      const monthName = new Date(item.month + "-01")
        .toLocaleString("default", { month: "short" });

      return (
        <tr key={idx}>
          <td>{item.emp_id}</td>
          <td>{item.emp_name}</td>

  
          <td>{monthName}</td>
          <td>{year || "-"}</td>

        
          {/* <td>{earnedBasic.toFixed(2) || 0}</td>
          <td>{pf.employeePF.toFixed(2) || 0}</td>
          <td>{pf.employerEPF.toFixed(2) || 0}</td>
          <td>{pf.employerEPS.toFixed(2) || 0}</td>
          <td>{pf.totalPF.toFixed(2) || 0}</td> */}

          <td>{(earnedBasic || 0).toFixed(2)}</td>
<td>{(pf?.employeePF || 0).toFixed(2)}</td>
<td>{(pf?.employerEPF || 0).toFixed(2)}</td>
<td>{(pf?.employerEPS || 0).toFixed(2)}</td>
<td>{(pf?.totalPF || 0).toFixed(2)}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="9">No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}



                {noteType?.value === 'pf_new_emp' && (
              <table className='table table-bordered table-striped table-hover text-center align-middle'>
                <thead className='table-info'>
                  <tr>
                    <th>Emp ID</th>
                    <th>Name</th>
                    <th>Phone</th>
                      <th>Email</th>
                    <th>Date OF Joining</th>
                  
        
                    
                  </tr>
                </thead>
               <tbody>
  {Array.isArray(fetchData) && fetchData.length > 0 ? (
    fetchData.map((item, idx) => {
   

      return (
        <tr key={idx}>
          <td>{item.emp_id}</td>
          <td>{item.first || ""} {item.middle || ""}  {item.last || ""}   </td>
          <td>{item.phone} </td>
           <td>{item.email} </td>
          <td>{item.doj} </td>
      
        </tr>
      );
    })
  ) : (
    <tr>
      <td >No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}


{noteType?.value === 'pf_contribution_card' && (
  <>
  
    <div className="p-3 border mb-3 bg-light">
      <h5 className="text-center fw-bold">FORM 3A (Revised)</h5>

      <p><b>Establishment:</b> {company.name} ({branchDetail.code})<br />  </p>
      <p><b>Financial Year:</b> {fromDate} to {toDate}</p>
      <p><b>Contribution Rate:</b> 12%</p>
    </div>

    {/* EMPLOYEES */}
    {Object.values(grouped).map((emp, i) => (
      <div key={i} className="mb-4">

        <h6 className="bg-dark text-white p-2">
        Name: {emp.emp_name}
        </h6>

        <table className="table table-bordered text-center">
          <thead className="table-info">
            <tr>
              <th>Month</th>
              <th>Earned Basic</th>
              <th>EPF</th>
              <th>Employer EPF</th>
              <th>Pension Fund</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            {emp.months.map((item, idx) => {
              const earnedBasic = getEarnedBasic(item);
              const pf = calculatePF(earnedBasic);

              const monthName = new Date(item.month + "-01")
                .toLocaleString("default", { month: "short" });

              return (
                <tr key={idx}>
                  <td>{monthName}</td>
                  {/* <td>{earnedBasic.toFixed(2)}</td>
                  <td>{pf.employeePF.toFixed(2)}</td>
                  <td>{pf.employerEPF.toFixed(2)}</td>
                  <td>{pf.employerEPS.toFixed(2)}</td> */}
                  <td>{(earnedBasic || 0).toFixed(2)}</td>
<td>{(pf.employeePF || 0).toFixed(2)}</td>
<td>{(pf.employerEPF || 0).toFixed(2)}</td>
<td>{(pf.employerEPS || 0).toFixed(2)}</td>
<td>{(pf.totalPF || 0).toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

      </div>
    ))}
  </>
)}



{noteType?.value === 'pf_challan' && (
  <div id="exportTable" className="p-3">

    {/* HEADER SECTION */}
    <div className="border p-3 mb-3">
      <h5 className="text-center fw-bold">
        EMPLOYEE PROVIDENT FUND ORGANISATION
      </h5>

      <p>
        <b>Establishment:</b> {company.name} ({branchDetail.code})<br />
      </p>

      <p>
        <b>Dues for Month:</b> {fetchData[0]?.month}
      </p>

      <p>
        <b>Total Employees:</b> {fetchData[0]?.total_employees}
      </p>
    </div>

    {/* TABLE */}
    <table className="table table-bordered text-center">
      <thead className="table-info">
        <tr>
          <th>Month</th>
          <th>Total Wages</th>
          <th>EPF A/C 1</th>
          <th>Pension A/C 10</th>
          <th>EDLI A/C 21</th>
          <th>Total Employees</th>
        </tr>
      </thead>

      <tbody>
        {fetchData.map((item, idx) => (
          <tr key={idx}>
            <td>{item.month}</td>
            <td>{item.total_wages.toFixed(2)}</td>
            <td>{item.employee_pf.toFixed(2)}</td>
            <td>{item.employer_eps.toFixed(2)}</td>
            <td>{(item.employee_pf * 0.01).toFixed(2)}</td>
            <td>{item.total_employees}</td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* BANK SECTION */}
<div className="border p-3 mt-4">

  <h6 className="fw-bold text-center">
    (FOR BANK USE ONLY)
  </h6>

  <div className="row">

    <div className="col-md-6">
      <p>Amount Received (Rs): ___________________</p>
    </div>

    <div className="col-md-6">
      <p>For Cheque Only</p>
    </div>

    <div className="col-md-6">
      <p>Date of Presentation: __/__/_____</p>
    </div>

    <div className="col-md-6">
      <p>Date of Realization: __/__/_____</p>
    </div>

    <div className="col-md-6">
      <p>Branch Name: ____________________</p>
    </div>

    <div className="col-md-6">
      <p>Branch Code: ____________________</p>
    </div>

    <div className="col-12">
      <p><b>Amount in Words:</b> __________________________</p>
    </div>

  </div>

  <hr />

  <p>
    <b>Establishment Name & Address:</b><br />
   {company.name} ({branchDetail.code})<br />
   {company.address}
  </p>

  <p>Name of Depositor: ________________________</p>
  <p>Signature of Depositor: ____________________</p>

  <p>
    Bank Name: ________  Cheque No: ________  Dated: ________
  </p>

</div>

  </div>
)}
                 </div>

            </div>

        </div>
    )
}

export default PFReport